<template>
    <div class="relative flex justify-end pr-6">
        <PageDropdownButton :actions="actions" />
    </div>
</template>
<script>
import { markRaw } from "vue";
import { PageDropdownButton } from "@easy/ui/page-components";
import {
    PencilSquareIcon,
    PencilLineIcon,
    CopyDocumentIcon,
    TrashBinIcon,
    ShareLinkIcon,
} from "@easy/ui/icons";

export default {
    name: "ProductRow",
    components: {
        PageDropdownButton,
    },
    emits: ["edit", "clone", "rename", "delete", "copyLink"],
    data() {
        return {
            showDropdown: false,
            actions: [
                {
                    icon: markRaw(PencilSquareIcon),
                    label: this.$t("shared.list.edit"),
                    handler: () => this.emitAndClose("edit"),
                },
                {
                    icon: markRaw(PencilLineIcon),
                    label: this.$t("shared.list.rename"),
                    handler: () => this.emitAndClose("rename"),
                },
                {
                    icon: markRaw(CopyDocumentIcon),
                    label: this.$t("shared.list.duplicate"),
                    handler: () => this.emitAndClose("clone"),
                },
                {
                    icon: markRaw(ShareLinkIcon),
                    label: this.$t("shared.share_modal.copy_link"),
                    handler: () => this.emitAndClose("copyLink"),
                },
                { isDivider: true },
                {
                    icon: markRaw(TrashBinIcon),
                    isDanger: true,
                    label: this.$t("shared.list.delete"),
                    handler: () => this.emitAndClose("delete"),
                },
            ],
        };
    },

    methods: {
        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
        },
        emitAndClose(action) {
            this.$emit(action);
            this.showDropdown = false;
        },
    },
};
</script>
